<template>
  <div class="card single-promo-card text-center shadow-sm border-0 rounded-4">
    <div class="card-body py-5 px-4">
      <div class="pb-3 d-flex justify-content-center">
        <div
          class="rounded-circle overflow-hidden border bg-light"
          style="aspect-ratio: 1; width: 80px;"
        >
          <img
            :src="agentPhoto && agentPhoto.trim() !== '' ? agentPhoto : '/assets/agent-avatar.png'"
            alt="Agent avatar"
            :class="['w-100 h-100', 'fade-img', loaded ? 'loaded' : '']"
            style="object-fit: contain; object-position: center;"
            @load="onImageLoad"
          />
        </div>
      </div>

      <h5 class="mb-1 fw-semibold">{{ agentFullname }}</h5>
      <p class="text-muted mb-2 small">
        <a
          v-if="agencyId"
          :href="`../agencies/${agencyId}`"
          class="text-decoration-none text-muted"
        >
          {{ agency }}
        </a>
        <span v-else>{{ agency }}</span>
      </p>
      <p v-if="telefon" class="text-muted small mb-0">
        <a
          :href="`https://wa.me/${telefon.replace(/\D/g, '')}`"
          class="text-dark fw-semibold text-decoration-none"
          target="_blank"
        >
          📞 {{ telefon }}
        </a>
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  agentFullname: { type: String, default: 'Имя агента' },
  agency: { type: String, default: 'Название агентства' },
  agencyId: { type: String },
  telefon: { type: String, default: null },
  agentPhoto: { type: String }
})

const loaded = ref(false)
const onImageLoad = () => {
  loaded.value = true
}
</script>

<style scoped>
.fade-img {
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}
.fade-img.loaded {
  opacity: 1;
}
</style>
